import { GruntPostRequestOptions, loggedOper as lp } from "./grunt";

const logInPath=process.env.REACT_APP_GRUNT_API+"/auth/login";
const getOperateri=process.env.REACT_APP_GRUNT_API+'/operater';
const pwdUpdate2=process.env.REACT_APP_GRUNT_API+'/operater/pwd2/';


const logInFunc= async (usr,pwd)=>{
    let postOpt=GruntPostRequestOptions;
    postOpt.body=JSON.stringify({"usr":usr,"pwd":pwd});
    try {
        const r=await fetch(logInPath,postOpt);
        const res=await r.json();
        lp.klijent_id=res.loggedOper.kliid;
        lp.klijent=res.loggedOper.kli;
        lp.operater_id=res.loggedOper.operid;
        lp.operater=res.loggedOper.oper;
        lp.token="JWT "+res.loggedOper.token;
        lp.uloga=res.loggedOper.uloga;
        lp.logged=true;
        return "ok";    
    } catch (error) {
        return {code: 'N/A', message: 'Krivo korisničko ime i/ili lozinka.', status: 401, name: 'Error'};
    }

}
    const updatePwd2= async(id,oldpwd,newpwd)=>{
        
        const _param={
            oldpwd:oldpwd,
            newpwd:newpwd
        };
        
        
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' ,'Authorization':lp.token},
            body: JSON.stringify(_param)
        };
        try {
            const r = await fetch(pwdUpdate2 + id, requestOptions);    
            const res=await r.json();
            return res;
        } catch (err) {
            return {status:err.status,message:err.message}
        }   
    }






export {logInFunc,getOperateri, updatePwd2};